import type { FC, PropsWithChildren } from 'react'

export const MaxWidthWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="mx-auto w-full max-w-3xl">
      {children}
    </div>
  )
}
